import SettingsContent from '../Wrapper';
import Index from './Index';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/queues'),
      component: SettingsContent,
      props: {
        headerTitle: 'QUEUES_MGMT.HEADER',
        icon: 'document-list-clock',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'queues_wrapper',
          roles: ['administrator'],
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'queues_list',
          roles: ['administrator'],
          component: Index,
        },
      ],
    },
  ],
};
